import React, { useState } from "react";
import StatutoryCard from "./StatutoryCard";
import AddStatutoryComponents from "./AddStatutoryComponents";
import SlidingPane from "react-sliding-pane";
import { useViewStatutoryComponents } from "../../queries/payrollQuries";
import { statutoryComponentTypeOptions } from "../../utils/commonSelectBoxOptions/commonSelectBoxOptions";

const PayrollStatutoryComponents = () => {
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [componentFilter, setComponentFilter] = useState(""); 

  const { data: allResponse = {}, isLoading, error } = useViewStatutoryComponents();
  const statutoryData = allResponse.data || [];

  const handleClosePane = () => {
    setIsPaneOpen(false);
    setEditData(null);
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setIsPaneOpen(true);
  };

  if (isLoading) return <div className="px-10 py-6">Loading statutory components...</div>;
  if (error) return <div className="px-10 py-6 text-red-500">Failed to load statutory components.</div>;

  return (
    <div className="py-6 w-full">
      <div className="px-10 flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
        <h2 className="text-xl font-semibold">Statutory Components</h2>

        <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">

          {/* Filter Dropdown */}
          <select
            value={componentFilter}
            onChange={(e) => setComponentFilter(e.target.value)}
            className="text-sm px-3 py-2 border border-gray-300 rounded w-full md:w-64"
          >
            <option value="">All Components</option>
            {statutoryComponentTypeOptions.map((type) => (
              <option key={type.value} value={type.value}>{type.label}</option>
            ))}
          </select>

          {/* Add Component Button */}
          <button
            className="btn text-sm font-medium bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={() => {
              setEditData(null);
              setIsPaneOpen(true);
            }}
          >
            Add Component
          </button>
        </div>
      </div>

      <div className="px-10">
        <StatutoryCard
          data={statutoryData}
          selectedType={componentFilter}
          onEdit={handleEditClick}
        />
      </div>

      {isPaneOpen && (
        <SlidingPane
          isOpen={isPaneOpen}
          title={editData ? "Edit Statutory Component" : "Add Statutory Component"}
          from="right"
          width="450px"
          onRequestClose={handleClosePane}
        >
          <AddStatutoryComponents
            closePane={handleClosePane}
            editData={editData}
            isEditMode={!!editData}
          />
        </SlidingPane>
      )}
    </div>
  );
};

export default PayrollStatutoryComponents;
